import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { MatDialogConfig, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmComponent } from '../../utils/confirm/confirm.component';
import { LoadingComponent } from './loading/loading.component';
import { ReportEmailDialogComponent } from './report-email-dialog/report-email-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
  	private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  public openSnackBar(message: string, action?: string, duration: number = 3000): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
		  duration: duration
		});
  }

  public openDialog(component, config: MatDialogConfig = { width: "600px", autoFocus: false }): MatDialogRef<any> {
    let dialogRef: MatDialogRef<any>;
    dialogRef = this.dialog.open(component, config);
    return dialogRef;
  }

  public confirm(config: { title?: string, message?: string, hasCancel?: boolean, button?:string, buttonFn?: ()=>void, color?: string, extraButton?: string, extraButtonFn?: () => void  }): Observable<boolean> {

    let dialogRef: MatDialogRef<ConfirmComponent>;

    dialogRef = this.dialog.open(ConfirmComponent, {
      data: config
    });
    return dialogRef.afterClosed();
  }

  public loading(): MatDialogRef<any> {
    let dialogRef: MatDialogRef<LoadingComponent>;
    dialogRef = this.dialog.open(LoadingComponent, {
      disableClose: true
    });
      
    return dialogRef;
  }

  public showNotificationDialog(title: string = null, message: string = null): MatDialogRef<any>{
    let dialogRef: MatDialogRef<ReportEmailDialogComponent>;
    dialogRef = this.dialog.open(ReportEmailDialogComponent, {
      disableClose: true,
      data: {
        title: title ? title : null,
        message: message ? message : null
      }
    });

    return dialogRef;
    
  }
}
